import { BUH_SUSPEND_TOOLTIP } from '../../utils/buhSuspend';
import './suspendHoverHint.css';

export default function SuspendHoverHint({ suspended, className = '', alwaysWrap = false, children }) {
    if (!suspended && !alwaysWrap && !className) {
        return children;
    }

    return (
        <div className={['suspend-hover-hint', className].filter(Boolean).join(' ')}>
            {children}
            {suspended && (
                <span className="suspend-hover-hint__bubble" role="tooltip">
                    {BUH_SUSPEND_TOOLTIP}
                </span>
            )}
        </div>
    );
}
